module.exports = __webpack_public_path__ + "img/profile__icon2.ec3719fb.png";